import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { bgTypeOptions, cropOptions } from 'src/app/core/const/settings';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-background-setup',
  templateUrl: './background-setup.component.html',
  styleUrls: ['./background-setup.component.css'],
})
export class BackgroundSetupComponent implements OnInit {
  @Input() settings: any;
  @Input() backgrounds: any;
  @Input() backgroundFiles: any;
  @Output() onSaveBgSetup = new EventEmitter<Object>();

  @ViewChild('dialogBgSetup') public dialogBgSetup: TemplateRef<any>;

  private modalDialogBgSetup: NgbModalRef;

  cropOptions = cropOptions;
  bgTypeOptions = bgTypeOptions;

  backgroundList: any[];
  backgroundListFiles: any[];
  defaultCropType: string;
  backgroundType: string;
  defaultBackground: any;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {}

  open(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalDialogBgSetup = this.modalService.open(this.dialogBgSetup);
      this.modalDialogBgSetup.result.then(resolve, resolve);
      this.backgroundList = this.backgrounds;
      console.log(this.backgroundList);
      this.backgroundListFiles = this.backgroundFiles;
      this.defaultCropType = this.settings.defaultCropType;
      this.backgroundType = this.settings.backgroundType;
      this.defaultBackground = this.settings.defaultBackground;
      if (this.settings.defaultCropType === 'half') {
        this.bgTypeOptions = bgTypeOptions.filter((type) =>
          [null, 'flat'].includes(type.value)
        );
      } else if (
        this.settings.defaultCropType === 'halfBlur' ||
        this.settings.defaultCropType === 'blur'
      ) {
        this.bgTypeOptions = [];
      } else {
        this.bgTypeOptions = bgTypeOptions;
      }
    });
  }

  async close(): Promise<void> {
    this.modalDialogBgSetup.close();
  }

  filterBackgroundOption(cropType: string) {
    if (cropType === 'half') {
      this.bgTypeOptions = bgTypeOptions.filter((type) =>
        ['flat'].includes(type.value)
      );
      this.backgroundType = null;
      this.defaultBackground = null;
    } else if (cropType === 'halfBlur' || cropType === 'blur') {
      this.bgTypeOptions = [];
      this.defaultBackground = this.settings.defaultBackground;
      this.backgroundType = this.settings.backgroundType;
    } else {
      this.bgTypeOptions = bgTypeOptions;
      this.backgroundType = null;
      this.defaultBackground = null;
    }
    this.backgroundListFiles = [];
    this.defaultCropType = cropType;
  }

  filterBackgroundType(bgType: any) {
    this.backgroundListFiles = [];
    this.backgroundList?.forEach(
      (background: { allowedTypes: any[]; backgroundFiles: any[] }) => {
        background.allowedTypes.forEach((type: any) => {
          if (type === bgType) {
            background.backgroundFiles.forEach(
              (file: { parameter: string }) => {
                if (file.parameter === 'preview') {
                  this.backgroundListFiles =
                    this.backgroundListFiles.concat(file);
                }
              }
            );
          }
        });
      }
    );
    this.defaultBackground = null;
    this.backgroundType = bgType;
  }

  selectedBg(bg: { id: any }) {
    this.defaultBackground = bg.id;
  }

  SaveBgSetup() {
    let body: any;
    body = {
      defaultCropType: this.defaultCropType,
    };
    if (this.backgroundType && this.defaultCropType && this.defaultBackground) {
      body['defaultCropType'] = this.defaultCropType;
      body['backgroundType'] = this.backgroundType;
      body['defaultBackground'] = this.defaultBackground;

      if (
        this.defaultCropType === 'full' &&
        this.backgroundType === 'platform'
      ) {
        if (!this.settings.features.includes('platform_360')) {
          this.toastr.info('Feature 360 will be switched ON.');
          body['features'] = [...this.settings.features, 'platform_360'];
        }

        this.onSaveBgSetup.emit({ body });
      } else {
        const featuresArray = ['platform_360'];

        let newFeatures = this.settings.features.filter(
          (f: string) => !featuresArray.includes(f)
        );

        this.toastr.info('Feature 360 will be switched OFF.');

        body['features'] = [...newFeatures];
        this.onSaveBgSetup.emit({ body, newFeatures });
      }

      if (this.defaultCropType !== 'full') {
        const featuresArray = [
          'platform_360',
          'reflectiveFloor',
          'refectiveFloorFull',
        ];
        let newFeatures = this.settings.features.filter(
          (f: string) => !featuresArray.includes(f)
        );

        body['features'] = [...newFeatures];
        this.onSaveBgSetup.emit({ body, newFeatures });
      }
      this.toastr.success('Successfully updated background settings');
      this.modalDialogBgSetup.close();
    } else {
      this.translate
        .get('errors.selectRequiredFields')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
    }
  }
}
